import type { FC, ReactNode } from 'react'

import { useState } from 'react'
import { Button } from '@/components/ui/button'
import { useRefresh } from '@/hooks/use-refresh'
import { CircleAlert, RefreshCw } from 'lucide-react'

interface LoadErrorProps {
    title?: string
}

const LoadError: FC<LoadErrorProps> = ({ title = 'No se pudieron cargar los datos' }): ReactNode => {
    const refresh = useRefresh()
    const [retrying, setRetrying] = useState(false)

    const handleRetry = async () => {
        setRetrying(true)

        try {
            await refresh()
        }
        finally {
            setRetrying(false)
        }
    }

    return (
        <div role='alert' className='flex flex-col items-center gap-4 rounded-xl border border-dashed bg-card px-6 py-14 text-center'>
            <span className='flex size-12 items-center justify-center rounded-full bg-danger-soft text-danger-ink'>
                <CircleAlert className='size-6' aria-hidden='true' />
            </span>

            <div className='flex max-w-md flex-col gap-1'>
                <p className='font-semibold'>
                    {title}
                </p>

                <p className='text-sm text-muted-foreground'>
                    La conexión con el inventario ha fallado por un momento. Tus datos están a salvo; vuelve a intentarlo.
                </p>
            </div>

            <Button onClick={handleRetry} disabled={retrying}>
                <RefreshCw className={retrying ? 'animate-spin' : undefined} aria-hidden='true' />
                {retrying ? 'Reintentando…' : 'Reintentar'}
            </Button>
        </div>
    )
}

export default LoadError
